export default function FilterIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10889 6.54622C5.27957 6.21105 5.62388 6 6 6H18C18.3761 6 18.7204 6.21105 18.8911 6.54622C19.0618 6.88139 19.03 7.28399 18.8087 7.58817L15 12.8252V19C15 19.3466 14.8206 19.6684 14.5257 19.8507C14.2309 20.0329 13.8628 20.0494 13.5528 19.8944L9.55279 17.8944C9.21401 17.725 9 17.3788 9 17V12.8252L5.19127 7.58817C4.97004 7.28399 4.93821 6.88139 5.10889 6.54622ZM7.96377 8L10.8087 11.9118C10.933 12.0827 11 12.2887 11 12.5V16.382L13 17.382V12.5C13 12.2887 13.067 12.0827 13.1913 11.9118L16.0362 8H7.96377Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
